import { useTranslation } from 'react-i18next';
import {
  Modal,
  StateIcon,
  Button,
  Input,
} from '@unified-checkout/design-system';
import {
  Check,
  LinkSimple,
  PaperPlane,
} from '@unified-checkout/design-system/icons/index';
import CopyText from '@app/dashboard/components/inner_layout/CopyText';
import styles from './first-time-setup-modal.module.scss';

export interface FirstTimeSetupModalProps {
  open: boolean;
  onClose: () => void;
  onShare: () => void;
  onViewSettings: () => void;
  paymeLink: string;
  canShare?: boolean;
  canViewSettings?: boolean;
}

export const FirstTimeSetupModal = ({
  open,
  onClose,
  onShare,
  onViewSettings,
  paymeLink,
  canShare = true,
  canViewSettings = true,
}: FirstTimeSetupModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onCloseHandler={onClose}
      hasCloseIcon={true}
      width="32rem"
      position="center"
      closeOnClickOutside={false}
      isOverlayAboveModal={true}
    >
      <div className={styles['first-time-setup-modal']}>
        <div className={styles['first-time-setup-modal__success-section']}>
          <StateIcon status="success" icon={Check} />
          <h3 className={styles['first-time-setup-modal__title']}>
            {t('innerLayout.paymePage.firstTimeSetupModal.title')}
          </h3>
          <p className={styles['first-time-setup-modal__description']}>
            {t('innerLayout.paymePage.firstTimeSetupModal.description')}
          </p>
        </div>

        <div className={styles['first-time-setup-modal__link-input']}>
          <Input
            id="payme-first-time-setup-link"
            name="payme-first-time-setup-link"
            type="text"
            value={paymeLink}
            onChange={() => {}}
            readOnly
            disabled
            leadingIcon={LinkSimple}
          />
          <div className={styles['first-time-setup-modal__copy-button']}>
            <CopyText textToCopy={paymeLink} />
          </div>
        </div>

        <div className={styles['first-time-setup-modal__divider']} />

        <div className={styles['first-time-setup-modal__actions']}>
          {canShare && (
            <Button
              color="primary"
              variant="contained"
              size="lg"
              label={t('innerLayout.paymePage.firstTimeSetupModal.shareButton')}
              leadingIcon={PaperPlane}
              onClickHandler={onShare}
            />
          )}
          {canViewSettings && (
            <Button
              color="secondary"
              variant="outlined"
              size="lg"
              label={t(
                'innerLayout.paymePage.firstTimeSetupModal.viewSettingsButton'
              )}
              onClickHandler={onViewSettings}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};
